import Layout from '@/layout'

export const routerList = [
  {
    path: '/asset',
    component: Layout,
    meta: {
      title: '资产',
      icon: 'icon-chanpinPIguanli-01'
    },
    alwaysShow: true,
    children: [
      {
        path: '/asset/purchase',
        component: () => import('@/views/Asset/Purchase'),
        name: 'AssetPurchase',
        meta: { title: '采购', affix: false }
      },
      {
        path: '/asset/purchase/detail',
        component: () => import('@/views/Asset/PurchaseDetail'),
        name: 'PurchaseDetail',
        meta: { title: '采购详情', affix: false },
        hidden: true
      },
      // {
      //   path: '/asset/fixed',
      //   component: () => import('@/views/Asset/FixedAsset'),
      //   name: 'FixedAsset',
      //   meta: { title: '固定资产', affix: false }
      // },
      // {
      //   path: '/asset/fixed/detail',
      //   component: () => import('@/views/Asset/FixedAssetDetail'),
      //   name: 'FixedAssetDetail',
      //   meta: { title: '固定资产详情', affix: false },
      //   hidden: true
      // },
      {
        path: '/asset/device',
        component: () => import('@/views/Asset/Device'),
        name: 'AssetDevice',
        meta: { title: '资产列表', affix: false }
      },
      {
        path: '/asset/device/detail',
        component: () => import('@/views/Asset/DeviceDetail'),
        name: 'DeviceDetail',
        meta: { title: '资产详情', affix: false },
        hidden: true
      },
      {
        path: '/asset/AssetType',
        component: () => import('@/views/Asset/AssetType'),
        name: 'AssetType',
        icon: 'icon-shezhi-01',
        meta: { title: '资产类型', affix: false }
      }
    ]
  }
]
